module.exports = __webpack_public_path__ + "img/Chatbanner(ReplaceMTFBanner).3eb21854.svg";